module.exports = __webpack_public_path__ + "img/logo_andalucia.2af56890.png";